import React from 'react';
import { Fade } from 'react-awesome-reveal';
import Header from 'parts/Header';
import Footer from 'parts/Footer';
import Button from '../elements/Button';

export default function TeamPage() {
  return (
    <div className="bg-gradient-to-r from-[#0a0a1d] to-[#14143a] min-h-screen text-white flex flex-col">
      <Header />

      {/* TEAM HERO SECTION */}
      <section className="container mx-auto px-6 py-16 flex flex-col md:flex-row items-center">
        <div className="w-full md:w-1/2 mb-12 md:mb-0">
          <Fade triggerOnce direction="up">
            <h1 className="text-4xl md:text-6xl font-bold mb-4 leading-tight">
              Ons team brengt jouw bedrijf naar nieuwe hoogten
            </h1>
          </Fade>
          <Fade triggerOnce direction="up" delay={200}>
            <p className="text-lg md:text-xl text-gray-200 mb-6">
              Bij Galactic Automation begeleiden we organisaties met innovatieve oplossingen in AI, data, cybersecurity en automatisering, zodat jij slimmer, veiliger en sneller kan groeien.
            </p>
          </Fade>
          <Fade triggerOnce direction="up" delay={400}>
            <Button href="/contact" type="link" className="bg-indigo-500 px-6 py-3 rounded-full font-bold hover:bg-indigo-600 transition duration-300">
              Neem contact op
            </Button>
          </Fade>
        </div>
      </section>

      {/* OUR PHILOSOPHY SECTION */}
      <section className="container mx-auto px-6 py-16">
        <Fade triggerOnce direction="up">
          <h2 className="text-4xl font-bold text-center mb-8">Onze filosofie</h2>
        </Fade>
        <Fade triggerOnce direction="up" delay={200}>
          <p className="text-center text-gray-200 text-xl max-w-3xl mx-auto">
            Wij geloven in een toekomst waarin technologie en innovatie toegankelijk zijn voor elke organisatie. Daarom bieden wij krachtige en betaalbare oplossingen op maat, die naadloos aansluiten bij jouw zakelijke ambities.
          </p>
        </Fade>
      </section>

      {/* SUPPORT FOR BUSINESSES SECTION */}
      <section className="bg-indigo-700 bg-opacity-20 py-16 px-6 text-center">
        <Fade triggerOnce direction="up">
          <h2 className="text-4xl font-bold mb-4">Waarom Galactic Automation?</h2>
          <ul className="text-lg text-gray-200 space-y-2">
            <li>✔ Geavanceerde oplossingen voor elke bedrijfsgrootte</li>
            <li>✔ Toegankelijke innovatie in AI, data en beveiliging</li>
            <li>✔ Persoonlijke begeleiding en maatwerk</li>
            <li>✔ Sterke focus op gebruiksvriendelijkheid en impact</li>
          </ul>
        </Fade>
      </section>

      <Footer />
    </div>
  );
}
